import { StoreHighlight } from "@/interfaces/domain/StoreHighlight";
import { api, image_path_highlights } from "@/services/api";

export async function getStoreHighlightsRequest(storeId: string) {
  const { data } = await api.get<StoreHighlight[]>(`/estabelecimentos/${storeId}/destaques`);
  return data?.map((item) => ({
    ...item,
    foto_destaque: `${image_path_highlights}/${item.foto_destaque}`,
  }));
}

export async function getStoreHighlightByIdRequest(id: string) {
  const { data } = await api.get<StoreHighlight>(`/destaques/${id}`);
  data.foto_destaque = `${image_path_highlights}/${data.foto_destaque}`;
  return data;
}
